export enum Gender {
  Man = 'M',
  Female = 'F'
}
export type UserInfo = {
  fio: string;
  gender: Gender;
  token: string;
};
